const DefaultValue = {
	LoanAmount: 10000,
}

export default DefaultValue;
